import { render } from "./Mail.vue?vue&type=template&id=f41cf0b8&scoped=true&ts=true"
import script from "./Mail.vue?vue&type=script&lang=ts"
export * from "./Mail.vue?vue&type=script&lang=ts"

import "./Mail.vue?vue&type=style&index=0&id=f41cf0b8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41cf0b8"]])

export default __exports__